<template>
  <router-link
    :to="`/trip/${code}`"
    class="text-stone-800 hover:text-emerald transition-colors duration-300"
  >
    <div class="p-2 text-center">
      <div
        v-if="promotionText"
        class="text-xs font-semibold text-brand-primary-strong uppercase tracking-wide min-h-[32px]"
      >
        {{ promotionText }}
      </div>
      <h2
        class="text-xl font-bold transition-colors duration-300 uppercase italic block min-h-[56px]"
      >
        {{ name }}
      </h2>
    </div>

    <div
      class="relative rounded-lg min-h-[320px] overflow-hidden trip-card card-glass block max-w-sm no-underline text-current"
    >
      <div class="trip-card__image-wrapper">
        <transition name="fade">
          <img
            v-if="currentPhoto"
            :key="currentPhoto"
            :src="currentPhoto"
            alt=""
            class="trip-card__image"
          />
        </transition>
      </div>
      <div class="px-3 pt-3 pb-4">
        <div class="text-sm block h-[100px] px-2 font-medium">
          {{ sellText }}
        </div>
        <div class="flex justify-between items-center mt-2 py-1 px-2">
          <span class="text-lg font-semibold"> {{ length }}</span>
          <div v-if="price" class="text-[0.7rem]">
            from
            <span class="text-lg font-semibold">{{ price }}</span>
          </div>
        </div>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  name: "TripCard",
  props: {
    name: {
      type: String,
      required: true,
    },
    map: {
      type: String,
      required: true,
    },
    photos: {
      type: Array,
      required: true,
    },
    length: {
      type: String,
      required: true,
    },
    price: {
      type: String,
      required: true,
    },
    sellText: {
      type: String,
      required: true,
    },
    code: {
      type: String,
      required: true,
    },
    promotionText: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      currentImageIndex: 0,
    };
  },
  computed: {
    currentPhoto() {
      if (!this.photos || !this.photos.length) return null;
      return this.photos[this.currentImageIndex % this.photos.length];
    },
  },
  methods: {},
};
</script>

<style scoped>
.trip-card {
  padding: 0;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
  box-shadow: var(--shadow-lg);
}

.trip-card:hover {
  transform: translateY(-6px) scale(1.02);
  box-shadow: var(--shadow-lg);
}

.trip-card__image-wrapper {
  position: relative;
  width: 100%;
  height: 220px;
  border-radius: 14px 14px 2px 2px;
  overflow: hidden;
}

.trip-card__image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.6s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
